import React from 'react';
import './Share.css'

function Share() {
    return (
      <div className="quote">
      
      </div>
    );
  }
  
  export default Share;